export const BASE_PATH = '/aem'

export const aemRecommendationsPath = () => `${BASE_PATH}/recommendations`
